document.addEventListener('DOMContentLoaded', function() {
  if (document.body.classList.contains('template-product')) {
      document.querySelectorAll('.products_addons .product-item-compact').forEach(function(item) {

          //variant change
          const dropdowns = item.querySelectorAll('.product-variant__container');
      
          dropdowns.forEach(dropdown => {
              dropdown.addEventListener('change', function() {
                  getAllDropdownValues(dropdown);
              });
          });
      
          function getAllDropdownValues(changedDropdown) {
              const values = [];
              dropdowns.forEach(dropdown => {
                  values.push(dropdown.value);
              });
              // console.log(values);
      
              // Find the parent product-item-compact__details element
              const productDetails = changedDropdown.closest('.product-item-compact__details');
              
              if (productDetails) {
                  const productAddonsRight = productDetails.querySelector('.product-addons-right');
                  if (productAddonsRight) {
                      const pro_json = productAddonsRight.getAttribute('data-pro-json');
                      if (pro_json) {
      
                        const parsedJson = JSON.parse(pro_json);
                        const new_arr = $.grep(parsedJson, function(n, i) {
                            // Check if the title includes all values
                            return values.every(value => n.title.includes(value));
                        });
        
                        new_arr.forEach(item => {
                            // console.log('ID:', item.id, 'Available:', item.available);
                           if(item.available){
                             const button = productAddonsRight.querySelector('button.product-addons-btn');
                             if(button){
                               const btn_avail_text = button.getAttribute('data-avail-text');
                               button.setAttribute('data-var-id',item.id);
                               button.removeAttribute('disabled');
                               if(btn_avail_text){
                                 button.textContent = btn_avail_text;
                               }else{
                                 button.textContent = 'Add';
                               }
                               button.classList.remove('disabled');
                             }
                           }else{
                             const button = productAddonsRight.querySelector('button.product-addons-btn');
                             if(button){
                               const btn_sold_text = button.getAttribute('data-sold-text');
                               if(btn_sold_text){
                                 button.textContent = btn_sold_text;
                               }else{
                                 button.textContent = 'Sold Out';
                               }
                               button.setAttribute('data-var-id',item.id);
                               button.setAttribute('disabled','disabled');
                               button.classList.add('disabled');
                             }
                           }
                        });
                      }
                  }
              }
          }

         //button click
          item.querySelector('button.product-addons-btn').addEventListener('click', function() {
              var variant_id = this.getAttribute('data-var-id');

              var requestBody = {
                  id: variant_id,
                  quantity: 1,
                  properties:{
                    '_upsell_below_atc':'true'
                  }
              };

              fetch('/cart/add.js', {
                  body: JSON.stringify(requestBody),
                  credentials: 'same-origin',
                  headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'xmlhttprequest'
                  },
                  method: 'POST'
              })
              .then((response) => response.json())
              .then((res) => {
                  fetch(window.location.href, {
                      method: 'GET',
                      headers: {
                          'Content-Type': 'text/html'
                      }
                  })
                  .then(response => response.text())
                  .then(htmlContent => {
                      const sectionInnerHTML = new DOMParser().parseFromString(htmlContent, 'text/html');
                      const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                      const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                      const cartItems = document.getElementById('AjaxCartForm');
                      cartItems.innerHTML = cartFormInnerHTML;

                      // Assuming ajaxifyCartItems is defined elsewhere
                      if (typeof cartItems.ajaxifyCartItems === 'function') {
                          cartItems.ajaxifyCartItems();
                      }

                      document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

                      document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
                          elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
                      });

                      document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
                          elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
                      });

                      document.querySelector('.site-header a.area--cart[aria-controls="site-cart-sidebar"]').click();

                      const screenReaderInfo = document.getElementById('screen-reader-info');
                      if (screenReaderInfo) {
                          screenReaderInfo.innerText = `${KROWN.settings.locales.cart_announcement}`;
                          setTimeout(() => {
                              screenReaderInfo.innerText = '';
                          }, 1000);
                      }
                  })
                  .catch(error => {
                      console.error("Error fetching and modifying HTML:", error);
                  });
              })
              .catch((err) => {
                  console.error(err);
              });
          });
      });
  }


  // ship protection product custom code

  $(document).on('change', '.so-package-protection-add-remove', function () {
    let isChecked = $(this).is(':checked');
    handlePackageProtectionChange(isChecked, this);
    // console.log(isChecked);
  });
  
    
  function handlePackageProtectionChange(isChecked, ele) {
    console.log('Package Protection Checked:', isChecked);
    const variantId = $(ele).data('variant-id');
  
    if (isChecked) {
      // Add product
      fetch(KROWN.settings.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(res => res.json())
        .then(data => {
            //refresh cart
            window.refreshCart();
        })
        .catch(err => console.error('Add failed', err));
    } else {
      //first get line id and remove product
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const lineItem = cart.items.find((item, index) => item.variant_id === variantId);
          if (!lineItem) {
            console.warn('Package protection not found in cart');
            return;
          }
          const lineIndex = cart.items.indexOf(lineItem) + 1; // Shopify line items are 1-based
  
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: lineIndex, quantity: 0 })
          });
        })
        .then(res => {
          if (res && res.ok) {
            // console.log('Package protection removed');
            //refresh cart
            window.refreshCart();
          } else if (res) {
            return res.json().then(data => {
              throw new Error('Remove failed: ' + JSON.stringify(data));
            });
          }
        })
        .catch(err => console.error(err));
    }
  } 
  
});